import Client from "../../../Client";
import { getProvinceVisitsSubmissions } from "../../../services/api/data/sameday";
import { AlertDrawerController } from "../../../views/sections/sidebar/AlertDrawer";
import { Notifier } from "../../conductor";
import Exceptions from "../../../Exceptions";
import { wait } from "../../../misc/date";
import { MainRouter } from "../../../routes";

export class SameDayProvinceSubmissionsController {
    constructor(options) {

        /** @type {{ lgu: string, id: string }} */
        this.reference = options.ref;

        const self = this;        
        this.notifiers = {
            ready: new Notifier(false),
            unauthorized: new Notifier(false),
            reloading: new Notifier(false),
            reloaded: new Notifier(),
            alert: new AlertDrawerController()
        };

        this.status = {
            get ready() { return self.notifiers.ready.get() },
            get reloading() { return self.notifiers.reloading.get() },
            get unauthorized() { return self.notifiers.unauthorized.get() }
        };

        this.initialize();
    }

    async initialize() {
        Client.ensureSignedIn();
        if(this.isInitialized) return; this.isInitialized = true;

        try {
            await this.loadData();
        } catch(e) {
            if(e.unauthorized) return this.notifiers.unauthorized.update(true);
        }
        
        this.notifiers.ready.update(true);
    }

    async loadData() {
        const { province, month, year } = this.reference;
        this.data = await getProvinceVisitsSubmissions({ province, month, year });
    }

    async refresh() {
        const { reloading, reloaded, alert } = this.notifiers;
        reloading.update(true);
        alert.close();

        try {
            await this.loadData();
            reloaded.notify();
        } catch(e) {
            const semantics = Exceptions.getARESemantics(e);
            alert.alert(semantics.message, { status: "error", title: semantics.title, retry: () => this.refresh() });
        }

        reloading.update(false);
    }
    
    async changeDate(month, year) {
        this.reference.month = month;
        this.reference.year = year;
        await this.refresh();

        MainRouter.pushPath(`/forms/sameday/province/${this.reference.province}/submissions/${month}/${year}`);
    }

    async viewLGUSubmissions(lguId) {
        const { month, year } = this.reference;
        MainRouter.goto(`/forms/sameday/lgu/${lguId}/submissions/${month}/${year}`);
    }
}